import { render, staticRenderFns } from "./ResetPasswordStep2.vue?vue&type=template&id=791f9970&scoped=true"
import script from "./ResetPasswordStep2.vue?vue&type=script&lang=js"
export * from "./ResetPasswordStep2.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordStep2.vue?vue&type=style&index=0&id=791f9970&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791f9970",
  null
  
)

export default component.exports